import React from "react";
import PrintOutlinedIcon from "@mui/icons-material/PrintOutlined";
import FlowActionButton from "@components/FlowActionButtons/FlowActionButton";

interface DownloadCsvButtonProps {
  langBase: string;
  permission: string;
  isActionAvailable: boolean;
  onDownloadCsv: () => void;
}

const DownloadCsvButton: React.FC<DownloadCsvButtonProps> = ({
  langBase,
  permission,
  isActionAvailable,
  onDownloadCsv,
}) => {
  return (
    <FlowActionButton
      langBase={langBase}
      permission={permission}
      isActionAvailable={isActionAvailable}
      labelKey="download-csv-button"
      testId="download-csv"
      variant="outlined"
      startIcon={<PrintOutlinedIcon />}
      onClick={onDownloadCsv}
    />
  );
};

export default DownloadCsvButton;
